export default __webpack_public_path__ + "static/media/splash_screen.321322ed.gif";